/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { TrfFromVanProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const trfFromVanProcessFetchTrfFromVanProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const trfFromVanProcessFetchTrfFromVanProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [TrfFromVanProcessTypes.TRF_FROM_VAN_PROCESS_FETCH_TRF_FROM_VAN_PROCESS_LOADING]: trfFromVanProcessFetchTrfFromVanProcessLoading,
  [TrfFromVanProcessTypes.TRF_FROM_VAN_PROCESS_FETCH_TRF_FROM_VAN_PROCESS_SUCCESS]: trfFromVanProcessFetchTrfFromVanProcessSuccess
});
